function cartApiUrl(path) {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root != null)
    ? String(window.Shopify.routes.root).replace(/\/$/, '')
    : '';
  return (root ? root + '/' : '/') + path.replace(/^\//, '');
}

var cartQuantitiesByVariant = {};

function loadCartQuantities() {
  return fetch(cartApiUrl('cart.js'), { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      cartQuantitiesByVariant = {};
      if (cart && cart.items) {
        cart.items.forEach(function (item) {
          var vid = String(item.variant_id);
          cartQuantitiesByVariant[vid] = (cartQuantitiesByVariant[vid] || 0) + item.quantity;
        });
      }
      return cartQuantitiesByVariant;
    })
    .catch(function () {
      return cartQuantitiesByVariant;
    });
}

function getInCartQuantity(variantId) {
  return cartQuantitiesByVariant[String(variantId)] || 0;
}

function initProductForm() {
  const forms = document.querySelectorAll('form[data-variants]');
  if (!forms.length) return;

  forms.forEach(function (form) {
    const variantIds = JSON.parse(form.dataset.variants);
    const variantOptions = JSON.parse(form.dataset.options);
    const variantAvailability = JSON.parse(form.dataset.availability);
    const variantInventory = JSON.parse(form.dataset.inventory || '{}');
    const variantPrices = JSON.parse(form.dataset.prices || '{}');
    const addToCartBtn = form.querySelector('.add-to-cart');

    function isPreorderVariant(variantId) {
      const params = window.GloboPreorderParams;
      if (!params || !params.preorderSettings || !params.preorderSettings.products) return false;
      const variantKey = String(variantId);
      const products = params.preorderSettings.products;
      for (const productId in products) {
        if (products[productId] && Object.prototype.hasOwnProperty.call(products[productId], variantKey)) {
          return true;
        }
      }
      return false;
    }

    function getPreorderRemaining(variantId) {
      const remaining = window.GloboPreorderParams && window.GloboPreorderParams.remainingUnits;
      if (!remaining || !Object.prototype.hasOwnProperty.call(remaining, String(variantId))) return null;
      const units = Number(remaining[variantId]);
      return Number.isFinite(units) ? Math.max(0, units) : null;
    }

    function getStockQuantity(variantId) {
      if (!variantAvailability[variantId]) return 0;
      if (isPreorderVariant(variantId)) {
        const preorderRemaining = getPreorderRemaining(variantId);
        if (preorderRemaining != null) return preorderRemaining;
        return 999999;
      }
      const raw = variantInventory[variantId];
      if (raw == null) return variantAvailability[variantId] ? 999999 : 0;
      return Math.max(0, Number(raw) || 0);
    }

    function getAddableQuantity(variantId) {
      return Math.max(0, getStockQuantity(variantId) - getInCartQuantity(variantId));
    }

    function getUiMaxQuantity(variantId) {
      return Math.min(getAddableQuantity(variantId), 10);
    }

    function refreshProductFormState() {
      const variantInput = form.querySelector('.product-variant-id');
      if (!variantInput) return;
      updateAddToCartButton(variantInput.value);
      updateQuantityOptions(variantInput.value);
      updatePrice(variantInput.value);
    }

    function updatePrice(variantId) {
      const price = variantPrices[variantId];
      if (price == null) return;
      // Update every price node: the theme button and any clone Globo Pre-Order
      // injects (the original button is hidden, so updating it alone is invisible).
      const priceEls = document.querySelectorAll('.add-to-cart-price');
      priceEls.forEach(function (el) { el.textContent = price; });
    }

    function updateUrl(variantId) {
      if (!window.history || !window.history.replaceState) return;
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    function syncQuantityFromGlobo() {
      if (typeof window.GloboPreorderParams === 'undefined') return;
      refreshProductFormState();
    }

    function syncQuantitySelection() {
      const quantityLabels = form.querySelectorAll('.quantity-options label');
      quantityLabels.forEach(function (label) {
        label.classList.remove('selected');
      });
      const checkedInput = form.querySelector('.quantity-options input[type="radio"]:checked:not(:disabled)');
      if (checkedInput) {
        const labelFor = form.querySelector('label[for="' + checkedInput.id + '"]');
        if (labelFor) labelFor.classList.add('selected');
      }
    }

    function updateAddToCartButton(variantId) {
      if (!addToCartBtn) return;
      var soldOutLabel = addToCartBtn.getAttribute('data-sold-out-label') || 'Sold out';
      var addToCartLabel = addToCartBtn.getAttribute('data-add-to-cart-label') || 'Add to cart';
      var labelTarget = addToCartBtn.querySelector('.add-to-cart-label') || addToCartBtn.querySelector('.mono.extra-small-font-size') || addToCartBtn;
      var addableQty = getAddableQuantity(variantId);
      var isPreorder = isPreorderVariant(variantId);
      var soldOut = !isPreorder && (!variantAvailability[variantId] || addableQty < 1);

      if (soldOut) {
        addToCartBtn.classList.add('sold-out');
        addToCartBtn.disabled = true;
        addToCartBtn.setAttribute('aria-disabled', 'true');
        labelTarget.textContent = soldOutLabel;
      } else {
        addToCartBtn.classList.remove('sold-out');
        addToCartBtn.disabled = false;
        addToCartBtn.removeAttribute('aria-disabled');
        if (!isPreorder) {
          labelTarget.textContent = addToCartLabel;
        }
      }
    }

    function updateQuantityOptions(variantId) {
      const maxQty = getUiMaxQuantity(variantId);
      const inputs = form.querySelectorAll('.quantity-options input[type="radio"]');
      inputs.forEach(function (input) {
        const qty = parseInt(input.value, 10);
        const unavailable = qty > maxQty;
        const label = form.querySelector('label[for="' + input.id + '"]');
        input.disabled = unavailable;
        input.classList.toggle('not-available', unavailable);
        if (label) label.classList.toggle('not-available', unavailable);
      });

      const checkedInput = form.querySelector('.quantity-options input[type="radio"]:checked');
      if (!checkedInput || checkedInput.disabled) {
        const fallback = form.querySelector('.quantity-options input[type="radio"]:not(:disabled)');
        if (fallback) fallback.checked = true;
      }
      syncQuantitySelection();
    }

    function updateVariantId(fromUser) {
      const optionsContainer = form.querySelector('.product-options');
      if (!optionsContainer) return;

      // Collect the selected value per option position so the array order always
      // matches variant.options order, regardless of DOM order (e.g. single-value
      // options rendered as hidden inputs after the visible dropdowns).
      const byPosition = {};
      function recordByName(name, value) {
        const match = name && name.match(/^option-(\d+)-/);
        if (!match) return;
        byPosition[parseInt(match[1], 10)] = value.trim();
      }
      optionsContainer.querySelectorAll('input[type=radio]:checked').forEach((radio) => {
        recordByName(radio.name, radio.value);
      });
      optionsContainer.querySelectorAll('select').forEach((select) => {
        recordByName(select.name, select.value);
      });
      const positions = Object.keys(byPosition).map(Number).sort((a, b) => a - b);
      const selectedOptions = positions.map((p) => byPosition[p]);

      const matchingVariantIndex = variantOptions.findIndex((variantOpts) => {
        return variantOpts.length === selectedOptions.length
          && variantOpts.every((opt, i) => opt === selectedOptions[i]);
      });
      if (matchingVariantIndex !== -1) {
        const variantId = variantIds[matchingVariantIndex];
        const variantInput = form.querySelector('.product-variant-id');
        if (variantInput) {
          variantInput.value = variantId;
        }
        refreshProductFormState();
        if (fromUser) {
          updateUrl(variantId);
        }
      } else {
        console.warn('No matching variant for:', selectedOptions);
      }
    }

    function closeProductOptionDropdown(dropdown) {
      const trigger = dropdown.querySelector('.product-option-dropdown__trigger');
      const list = dropdown.querySelector('.product-option-dropdown__list');
      const arrow = dropdown.querySelector('.product-option-dropdown__arrow');
      dropdown.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (list) list.hidden = true;
      if (arrow) arrow.textContent = '↓';
    }

    function initProductOptionDropdowns() {
      const optionsContainer = form.querySelector('.product-options');
      if (!optionsContainer) return;

      optionsContainer.querySelectorAll('.product-option-dropdown').forEach(function (dropdown) {
        const trigger = dropdown.querySelector('.product-option-dropdown__trigger');
        const list = dropdown.querySelector('.product-option-dropdown__list');
        const arrow = dropdown.querySelector('.product-option-dropdown__arrow');
        const valueEl = dropdown.querySelector('.product-option-dropdown__value');
        const radios = dropdown.querySelectorAll('input[type=radio]');

        function syncTriggerLabel() {
          const checked = dropdown.querySelector('input[type=radio]:checked');
          if (checked && valueEl) valueEl.textContent = checked.value;
        }

        if (trigger) {
          trigger.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (dropdown.classList.contains('is-open')) {
              closeProductOptionDropdown(dropdown);
              return;
            }
            optionsContainer.querySelectorAll('.product-option-dropdown.is-open').forEach(closeProductOptionDropdown);
            dropdown.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            if (list) list.hidden = false;
            if (arrow) arrow.textContent = '↑';
          });
        }

        radios.forEach(function (radio) {
          radio.addEventListener('change', function () {
            syncTriggerLabel();
            closeProductOptionDropdown(dropdown);
            updateVariantId(true);
          });
        });

        dropdown.querySelectorAll('.product-option-dropdown__item').forEach(function (item) {
          item.addEventListener('click', function (e) {
            const radio = item.querySelector('input[type=radio]');
            if (!radio || radio.checked) return;
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
            e.preventDefault();
          });
        });

        syncTriggerLabel();
      });
    }

    form.addEventListener('change', function (e) {
      const optionsContainer = form.querySelector('.product-options');
      if (!optionsContainer || !optionsContainer.contains(e.target)) return;
      if (
        e.target.matches('input[type=radio]') ||
        e.target.matches('select')
      ) {
        updateVariantId(true);
      }
    });

    document.addEventListener('cart:updated', function () {
      loadCartQuantities().then(refreshProductFormState);
    });

    loadCartQuantities().then(function () {
      initProductOptionDropdowns();
      updateVariantId();
      setTimeout(syncQuantityFromGlobo, 500);
    });
  });

  if (!window.__productOptionDropdownCloseBound) {
    window.__productOptionDropdownCloseBound = true;
    document.addEventListener('click', function (e) {
      if (e.target.closest('.product-option-dropdown')) return;
      document.querySelectorAll('.product-option-dropdown.is-open').forEach(function (dropdown) {
        const trigger = dropdown.querySelector('.product-option-dropdown__trigger');
        const list = dropdown.querySelector('.product-option-dropdown__list');
        const arrow = dropdown.querySelector('.product-option-dropdown__arrow');
        dropdown.classList.remove('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (list) list.hidden = true;
        if (arrow) arrow.textContent = '↓';
      });
    });
  }
}

// Globo Pre-Order clones the add-to-cart button copying the theme's "sold-out" class
// and may keep it disabled, leaving the preorder button struck-through and unclickable.
// Whenever a button becomes a Globo preorder button, strip those so it stays clickable.
function keepPreorderButtonsClickable() {
  function cleanButton(btn) {
    if (!btn || !btn.classList.contains('gPreorderBtn')) return;
    if (btn.classList.contains('sold-out')) btn.classList.remove('sold-out');
    if (btn.disabled) btn.disabled = false;
    if (btn.getAttribute('aria-disabled') === 'true') btn.removeAttribute('aria-disabled');
  }

  function scan() {
    document.querySelectorAll('.add-to-cart.gPreorderBtn').forEach(cleanButton);
  }

  scan();

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.target && m.target.classList && m.target.classList.contains('gPreorderBtn')) {
        cleanButton(m.target);
      }
      if (m.addedNodes) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.classList && node.classList.contains('gPreorderBtn')) {
            cleanButton(node);
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class', 'disabled', 'aria-disabled'],
  });
}

function initProductDescriptionTabs() {
  const descriptionValueNotes = document.querySelector('.description-value-notes');

  function activateTab(label) {
    const tabName = label.getAttribute('data-tab');
    const allLabels = document.querySelectorAll('.description-labels .description-label');
    const allValues = document.querySelectorAll('.description-values .description-value');

    allLabels.forEach((l) => l.classList.remove('active'));

    allValues.forEach((value) => {
      value.style.display = 'none';
      value.classList.remove('active');
    });

    label.classList.add('active');

    if (tabName !== 'description' && descriptionValueNotes) {
      const notesValues = descriptionValueNotes.querySelectorAll('.description-value');
      notesValues.forEach((value) => {
        value.style.display = 'block';
        if (value.getAttribute('data-tab-content') === tabName) {
          value.classList.add('active');
        } else {
          value.classList.remove('active');
        }
      });
      descriptionValueNotes.classList.add('active');
      descriptionValueNotes.style.display = 'block';
    } else {
      const targetValue = document.querySelector(`[data-tab-content="${tabName}"]`);
      if (targetValue) {
        targetValue.style.display = 'block';
      }
      if (descriptionValueNotes) {
        descriptionValueNotes.classList.remove('active');
        descriptionValueNotes.style.display = 'none';
      }
    }
  }

  const allValues = document.querySelectorAll('.description-values .description-value');
  allValues.forEach((value) => {
    if (value.getAttribute('data-tab-content') === 'description') {
      value.style.display = 'block';
    } else {
      value.style.display = 'none';
    }
  });

  const descriptionLabel = document.querySelector('[data-tab="description"]');
  if (descriptionLabel) {
    descriptionLabel.classList.add('active');
  }

  function setupEventListeners() {
    const isDesktop = window.innerWidth > 820;

    const allLabels = document.querySelectorAll('.description-labels .description-label');

    allLabels.forEach((label) => {
      const newLabel = label.cloneNode(true);
      label.parentNode.replaceChild(newLabel, label);
    });

    const newLabels = document.querySelectorAll('.description-labels .description-label');

    if (isDesktop) {
      newLabels.forEach((label) => {
        label.addEventListener('mouseenter', function () {
          activateTab(this);
        });
      });
    } else {
      newLabels.forEach((label) => {
        label.addEventListener('click', function () {
          activateTab(this);
        });
      });
    }
  }

  setupEventListeners();

  window.addEventListener('resize', setupEventListeners);
}

function initProductQuantityOptions() {
  const forms = document.querySelectorAll('form[data-variants]');

  forms.forEach(function (form) {
    const quantityInputs = form.querySelectorAll('.quantity-options input[type="radio"]');
    const quantityLabels = form.querySelectorAll('.quantity-options label');

    quantityInputs.forEach((input) => {
      if (input.checked) {
        const labelFor = form.querySelector('label[for="' + input.id + '"]');
        if (labelFor) {
          labelFor.classList.add('selected');
        }
      }

      input.addEventListener('change', function () {
        quantityLabels.forEach((label) => label.classList.remove('selected'));

        const labelFor = form.querySelector('label[for="' + this.id + '"]');
        if (labelFor) {
          labelFor.classList.add('selected');
        }
      });
    });
  });
}

function monitorAddToCartVisibility() {
  const addToCartButton = document.querySelector('.add-to-cart');
  const footer = document.querySelector('#footer');

  if (!addToCartButton || !footer) return;

  function checkFooterVisibility() {
    const isMobile = window.innerWidth < 820;
    if (!isMobile) {
      addToCartButton.classList.remove('hidden');
      return;
    }

    const footerRect = footer.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    if (footerRect.top < viewportHeight) {
      addToCartButton.classList.add('hidden');
    } else {
      addToCartButton.classList.remove('hidden');
    }
  }

  checkFooterVisibility();

  window.addEventListener('scroll', checkFooterVisibility, { passive: true });
  window.addEventListener('resize', checkFooterVisibility);
}

document.addEventListener('DOMContentLoaded', function () {
  try {
    initProductForm();
  } catch (e) {
    if (console && console.error) console.error('Product form init error', e);
  }
  try {
    keepPreorderButtonsClickable();
  } catch (e) {
    if (console && console.error) console.error('Preorder button cleanup error', e);
  }
  try {
    initProductDescriptionTabs();
  } catch (e) {
    if (console && console.error) console.error('Product description tabs init error', e);
  }
  try {
    initProductQuantityOptions();
  } catch (e) {
    if (console && console.error) console.error('Product quantity options init error', e);
  }
  try {
    monitorAddToCartVisibility();
  } catch (e) {
    if (console && console.error) console.error('Monitor add to cart visibility error', e);
  }
});
